import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import AdminHome from "./AdminHome";
import AdminNavbar from "./AdminNavbar";
import AdminFooter from "./AdminFooter";

// Events Imports
import AdminEvents from "./AdminEvents";
import EventForm from "./EventForm";
import EditEventForm from "./EditEventForm";
import { verifyAdmin } from "../../../utils/verifyAdmin";

// Resources Imports
import AdminResources from "./AdminResources";
import ResourceForm from "./ResourceForm";
import EditResourceForm from "./EditResourceForm";

// Gallery Imports
import AdminGallery from "./AdminGallery";
import GalleryForm from "./GalleryForm";

// Team Persons Imports
import AdminTeam from "./AdminTeam";
import PersonForm from "./PersonForm";
import EditPersonForm from "./EditPersonForm";

// Quotes Imports
import AdminQuotes from "./AdminQuotes";
import QuoteForm from "./QuoteForm";

// Trending Links Imports
import AdminLinks from "./AdminLinks";
import LinkForm from "./LinkForm";

// Announcements Imports
import AdminAnnouncements from "./AdminAnnouncements";
import AnnouncementForm from "./AnnouncementForm";

function Admin() {
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        verifyAdmin()
            .then(() => {
                setIsAdmin(true);
            })
            .catch(() => {
                navigate("/login");
            });
    });

    if (isAdmin) {
        return (
            <div className="min-vh-100 is-flex is-flex-direction-column is-align-content-center is-justify-content-space-between">
                <AdminNavbar />
                <Routes>
                    <Route path="/" element={<AdminHome />} />
                    {/* Events */}
                    <Route path="/events" element={<AdminEvents />} />
                    <Route path="/events/new" element={<EventForm />} />
                    <Route
                        path="/events/edit/:id"
                        element={<EditEventForm />}
                    />
                    {/* Resources */}
                    <Route path="/resources" element={<AdminResources />} />
                    <Route path="/resources/new" element={<ResourceForm />} />
                    <Route
                        path="/resources/edit/:id"
                        element={<EditResourceForm />}
                    />
                    {/* Gallery */}
                    <Route path="/gallery" element={<AdminGallery />} />
                    <Route path="/gallery/new" element={<GalleryForm />} />
                    {/* Team (Persons) */}
                    <Route path="/team" element={<AdminTeam />} />
                    <Route path="/team/new" element={<PersonForm />} />
                    <Route path="/team/edit/:id" element={<EditPersonForm />} />
                    {/* Announcements */}
                    <Route
                        path="/announcements"
                        element={<AdminAnnouncements />}
                    />
                    <Route
                        path="/announcements/new"
                        element={<AnnouncementForm />}
                    />
                    {/* Quotes */}
                    <Route path="/quotes" element={<AdminQuotes />} />
                    <Route path="/quotes/new" element={<QuoteForm />} />
                    {/* Trending Links */}
                    <Route path="/links" element={<AdminLinks />} />
                    <Route path="/links/new" element={<LinkForm />} />
                </Routes>
                <AdminFooter />
            </div>
        );
    } else {
        return null;
    }
}

export default Admin;
